"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityAddStatementsNFTAccountHeader from "./UserPageIdentityAddStatementsNFTAccountHeader";
import { NFT_ACCOUNTS_STATEMENT_TYPE, STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import UserPageIdentityAddStatementsForm from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsForm";
import UserPageIdentityAddStatementsNFTAccountItems from "./UserPageIdentityAddStatementsNFTAccountItems";
export default function UserPageIdentityAddStatementsNFTAccounts(t0) {
  const $ = _c(12);
  const {
    onClose,
    profile
  } = t0;
  const [nftAccountType, setNFTAccountType] = useState(STATEMENT_TYPE.SUPER_RARE);
  const group = STATEMENT_GROUP.NFT_ACCOUNTS;
  let t1;
  if ($[0] !== onClose) {
    t1 = <UserPageIdentityAddStatementsNFTAccountHeader onClose={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== nftAccountType) {
    t2 = <UserPageIdentityAddStatementsNFTAccountItems activeType={nftAccountType} setType={setNFTAccountType} />;
    $[2] = nftAccountType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== nftAccountType || $[5] !== onClose || $[6] !== profile) {
    t3 = <UserPageIdentityAddStatementsForm activeType={nftAccountType} group={group} profile={profile} onClose={onClose} />;
    $[4] = nftAccountType;
    $[5] = onClose;
    $[6] = profile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}